import { useXHR } from "@sembark-travel/xhr"
import {
	NewPGSimulatorIntegrationForm,
	type TIntegration,
} from "../../../../Integrations"
import { Box, Container } from "@sembark-travel/ui/base"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { showSnackbar } from "@sembark-travel/ui/snackbar"

export default function NewPGSimulatorIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New PG Simulator Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New PG Simulator Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					["", "PG Simulator Integrations"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewPGSimulatorIntegrationForm
								initialValues={{
									name: "Payment Solutions using Simulator",
									description:
										"Manage Payments using Payment Gateway Simulator",
								}}
								onSubmit={async (values) => {
									const integration = await xhr
										.post<{ data: TIntegration }>("integrations", {
											...values,
										})
										.then((resp) => resp.data.data)
									showSnackbar("Integration created successfully.")
									navigate("/integrations/:integrationId/pg", {
										params: {
											integrationId: String(integration.uid),
										},
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/org/integrations", { replace: true })
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
